export enum CompanyPageView {
  AssignedUsers,
  OrderFilePermissions,
}
